import { values } from "lodash";
import { RoleByService } from "../_services/roleby.service";

export const roleAction = {
  OngoingPreventiveActionListByRole,
  CompletedPreventiveActionListByRole,
  getPreventiveListByRole,
  getPreventiveCountByRole,
  getOngoingPreventiveActionCountByRole,
  getCompletedPreventiveActionCountByRole,
  getAllCountByRole,
  getStatisticalReport,
  TotalAppUsersCountByRole,
  getArrestReportByRole,
  getReportSpotviseByRole,
  getGpsinformationByRole,
  getQrInformationByRole,
  getCriminalsTableInfoByRole,
  getCriminalsAppInfoSearchByrole,
  getGunaHeadingArophiFilterByRole,
  getCriminalsHeadingFilterByRole,
  getFilterCriminalsTableInfoByRole,
  gunaYearWiseByRole,
  totaltwoplusCountByRole,
  preventionActionCountByRole,
  surveillanceCountByRole,
  totalappuserCountByRole,
  filledPoliceStationDailyByRole,
  notFilledPoliceStationDailyByRole,
  getWantedCountByRole,
  getConditionWantedByRole,
  getTadipaarCountByRole,
  getTadipaarByRole,
  getListGunaReportByRole,
  getCountGunaReportByRole,
  gunaFilterDropDownByRole,
  noticeCountByRole,
  noticeListByRole,
  getArrestCountByRole,
  noticeGraphByRole,
  arrestGraphByRole,
  gunaGraphByRole,
  getPreventiveActionAnalyticsByRole,
  getPreventiveActionAnalyticsListByRole
};
function OngoingPreventiveActionListByRole(values) {
  return RoleByService.OngoingPreventiveActionListByRole(values);
}
function CompletedPreventiveActionListByRole(values) {
  return RoleByService.CompletedPreventiveActionListByRole(values);
}
function getPreventiveListByRole(values) {
  return RoleByService.getPreventiveListByRole(values);
}
function getPreventiveCountByRole(values) {
  return RoleByService.getPreventiveCountByRole(values);
}
function getOngoingPreventiveActionCountByRole(values) {
  return RoleByService.getOngoingPreventiveActionCountByRole(values);
}
function getCompletedPreventiveActionCountByRole(values) {
  return RoleByService.getCompletedPreventiveActionCountByRole(values);
}
function getAllCountByRole(values) {
  return RoleByService.getAllCountByRole(values);
}
function getStatisticalReport(values) {
  return RoleByService.getStatisticalReport(values);
}
function TotalAppUsersCountByRole(values) {
  return RoleByService.TotalAppUsersCountByRole(values);
}
function getArrestReportByRole(values) {
  return RoleByService.getArrestReportByRole(values);
}
function getReportSpotviseByRole(values) {
  return RoleByService.getReportSpotviseByRole(values);
}
function getGpsinformationByRole(values) {
  return RoleByService.getGpsinformationByRole(values);
}
function getQrInformationByRole(values) {
  return RoleByService.getQrInformationByRole(values);
}
function getCriminalsTableInfoByRole(values) {
  return RoleByService.getCriminalsTableInfoByRole(values);
}
function getCriminalsAppInfoSearchByrole(values) {
  return RoleByService.getCriminalsAppInfoSearchByrole(values);
}
function getGunaHeadingArophiFilterByRole(values) {
  return RoleByService.getGunaHeadingArophiFilterByRole(values);
}
function getCriminalsHeadingFilterByRole(values) {
  return RoleByService.getCriminalsHeadingFilterByRole(values);
}
function getFilterCriminalsTableInfoByRole(values) {
  return RoleByService.getFilterCriminalsTableInfoByRole(values);
}
function gunaYearWiseByRole(values) {
  return RoleByService.gunaYearWiseByRole(values);
}
function totaltwoplusCountByRole(values) {
  return RoleByService.totaltwoplusCountByRole(values);
}
function preventionActionCountByRole(values) {
  return RoleByService.preventionActionCountByRole(values);
}
function surveillanceCountByRole(values) {
  return RoleByService.surveillanceCountByRole(values);
}
function totalappuserCountByRole(values) {
  return RoleByService.totalappuserCountByRole(values);
}
function filledPoliceStationDailyByRole(values) {
  return RoleByService.filledPoliceStationDailyByRole(values);
}
function notFilledPoliceStationDailyByRole(values) {
  return RoleByService.notFilledPoliceStationDailyByRole(values);
}
function getWantedCountByRole(values) {
  return RoleByService.getWantedCountByRole(values);
}
function getConditionWantedByRole(values) {
  return RoleByService.getConditionWantedByRole(values);
}
function getTadipaarCountByRole(values) {
  return RoleByService.getTadipaarCountByRole(values);
}
function getTadipaarByRole(values) {
  return RoleByService.getTadipaarByRole(values);
}
function getListGunaReportByRole(values) {
  return RoleByService.getListGunaReportByRole(values);
}
function getCountGunaReportByRole(values) {
  return RoleByService.getCountGunaReportByRole(values);
}
function gunaFilterDropDownByRole(values) {
  return RoleByService.gunaFilterDropDownByRole(values);
}
function noticeCountByRole(values) {
  return RoleByService.noticeCountByRole(values);
}
function noticeListByRole(values) {
  return RoleByService.noticeListByRole(values);
}
function getArrestCountByRole(values) {
  return RoleByService.getArrestCountByRole(values);
}
function noticeGraphByRole(values) {
  return RoleByService.noticeGraphByRole(values);
}
function arrestGraphByRole(values) {
  return RoleByService.arrestGraphByRole(values);
}
function gunaGraphByRole(values) {
  return RoleByService.gunaGraphByRole(values);
}
function getPreventiveActionAnalyticsByRole(values) {
  return RoleByService.getPreventiveActionAnalyticsByRole(values);
}
function getPreventiveActionAnalyticsListByRole(values){
  return RoleByService.getPreventiveActionAnalyticsListByRole(values)
}